import styled, { css, keyframes } from 'styled-components';
import tokens from '../../../foundation/tokens/js/tokens';
// styled-components.
// -----------------------------------------------------------------------------
const pulseAnimation = keyframes `
  0% { background-color: ${tokens.colors.midnight[100].value}; }
  100% { background-color: ${tokens.colors.midnight[300].value}; }
`;
const waveAnimation = keyframes `
  to { background-position-x: -20%; }
`;
const PULSE_CSS = css `
  opacity: 0.7;
  animation: ${pulseAnimation} 1s linear infinite alternate;

  /*
  width: 100%;
  height: 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: 0.125rem;
  */
`;
const WAVE_CSS = css `
  background-color: ${tokens.colors.midnight[200].value};
  background: linear-gradient(
      100deg,
      rgba(255, 255, 255, 0) 40%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 60%
    )
    ${tokens.colors.midnight[200].value};

  background-size: 200% 100%;
  background-position-x: 180%;
  animation: ${waveAnimation} 1s ease-in-out infinite;
`;
export const SkeletonCircularRoot = styled.div `
  ${({ animation, radius }) => {
    return css `
      border-radius: ${radius}px;
      height: ${radius * 2}px;
      width: ${radius * 2}px;

      ${animation === 'pulse' && PULSE_CSS}
      ${animation === 'wave' && WAVE_CSS}
    `;
}}
`;
export const SkeletonRectangularRoot = styled.div `
  ${({ animation, height, width }) => {
    return css `
      height: ${height};
      width: ${width};

      ${animation === 'pulse' && PULSE_CSS}
      ${animation === 'wave' && WAVE_CSS}
    `;
}}
`;
export const SkeletonRoundedRoot = styled.div `
  ${({ animation, borderRadius, height, width }) => {
    return css `
      border-radius: ${borderRadius};
      height: ${height};
      width: ${width};

      ${animation === 'pulse' && PULSE_CSS}
      ${animation === 'wave' && WAVE_CSS}
    `;
}}
`;
//# sourceMappingURL=Skeleton.styled.js.map